import { useNavigate } from "react-router-dom";
import "./Missing.scss";

const Missing = () => {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <div className="missing">
            <div className="missing__content">
                <h1 className="missing__code">404</h1>
                <h2 className="missing__title">Page Not Found</h2>

                <p className="missing__text">
                    Please{" "}
                    <button className="missing__button" onClick={goBack}>
                        Go Back
                    </button>
                </p>
            </div>
        </div>
    );
};

export default Missing;
